module.exports = __webpack_public_path__ + "fd5a608a/img/15000000-8.e1f78ed3.jpg";